import { Component, OnInit, Input, Output, ViewEncapsulation, EventEmitter, OnDestroy } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';

import { Tab } from 'commons-lib';

import { forkJoin, Subscription } from 'rxjs';

import { EditFacCombosModel, FullFacModel, EditFacFunnelStagesModel } from '../../../core/models/edit-fac-modal.model';
import { ButtonsPopupModel } from '../buttons-popup/buttons-popup.model';
import { FacsService } from 'src/app/facs/service/facs.service';
import { EditFacModalService } from './service/edit-fac-modal.service';
import { WindowScrollService } from 'src/app/core/services/window-scroll.service';
import { validateCPF, validateDateRange, validateHaveCep } from '../../../core/validators/edit-fac-modal.validators';
import { ButtonsPopupService } from '../buttons-popup/service/buttons-popup.service';
import { SnackbarService } from '../snackbar/service/snackbar.service';
import { OrderCard } from 'src/app/core/models/facs.model';
import { EnvironmentService } from 'src/app/core/enviroment/environment.service';
import { GoogleTagManagerService } from 'src/app/core/analytics/google-tag-manager.service';

@Component({
  selector: 'app-edit-fac-modal',
  templateUrl: './edit-fac-modal.component.html',
  styleUrls: ['./edit-fac-modal.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class EditFacModalComponent implements OnInit, OnDestroy {

  @Input() public orderCard: OrderCard = {
    above_fac_id: null,
    below_fac_id: null
  };
  @Input() show = false;
  @Input() facdId = '';
  @Input() columnType: EditFacFunnelStagesModel = {
    value: '',
    sub_items: []
  };
  @Input() removeGlobalScroll = true;
  featureLogTab = this.environmentService.getEnvVar('feature_log_tab') === 'true';

  @Output() closeM = new EventEmitter<boolean>();

  public filesToUpload: any[];
  public searchProfileEditObj = {
    id: null,
    idx: 0
  };

  public readonly modalDescriptions = {
    changed: 'Informações obrigatórias em vermelho não foram preenchidas e não serão salvas. Tem certeza que deseja sair?',
    same: 'As informações do registro da atividade não foram salvas. Tem certeza que deseja sair?'
  };

  public readonly popModal: ButtonsPopupModel = {
    title: 'Atenção',
    description: '',
    buttons: [
      {
        btnType: 3,
        title: 'Permanecer',
        func: () => { }
      },
      {
        btnType: 1,
        title: 'Sair',
        func: () => { this.closeModal(); }
      }
    ]
  };

  public tabs: Tab[] = this.featureLogTab ? [
    new Tab(0, true, 'Geral'),
    new Tab(1, false, 'Perfil de busca'),
    new Tab(2, false, 'Mais detalhes'),
    new Tab(3, false, 'Log')
  ] : [
      new Tab(0, true, 'Geral'),
      new Tab(1, false, 'Perfil de busca'),
      new Tab(2, false, 'Mais detalhes')
    ];

  public newFac = false;
  public combosList: EditFacCombosModel;
  public facItem: FullFacModel;
  public loaderSubscription: Subscription;
  public isLoading = true;
  public openModal = false;

  public renderFilesUploadModal = false;
  public uploadModalHidden = false;
  public showSearchProductModal = false;
  public showOfferedProduct = false;
  public showOriginLead = false;
  public operationMarkets: number;
  public showEmail = false;
  public geralForm: FormGroup;
  public moreInfoForm: FormGroup;
  public searchProfileForm: FormGroup;

  constructor(
    private favService: FacsService,
    private editFacService: EditFacModalService,
    private windowService: WindowScrollService,
    private formBuilder: FormBuilder,
    private btnsService: ButtonsPopupService,
    private snackbarService: SnackbarService,
    private environmentService: EnvironmentService,
    private googleTagService: GoogleTagManagerService
  ) { }

  public featureProductSheet = this.environmentService.getEnvVar('feature_product_sheet') === 'true';
  ngOnInit() {
    this.loaderSubscription = this.editFacService.getLoading().subscribe(state => this.isLoading = state);
    this.windowService.disable();
    this.facdId === '' ? this.newFac = true : this.newFac = false;
    this.checkOperationMarkets();
    this.loaderData();
  }

  private loaderData() {
    forkJoin(
      this.editFacService.getCombos(),
      this.editFacService.getFacById(this.facdId)
    ).subscribe(resp => {
      this.combosList = resp[0];
      this.facItem = resp[1];
      this.sendGATagOnOpenFAC();

      if (!this.columnType.value) {
        this.columnType = this.facItem.funnel_stage;
      }
      if (this.facItem.badges) {
        if (this.facItem.badges.some(item => item.name === 'REAL_STATE_DEVELOPER_SELLER')) {
          this.snackbarService.show('Atenção: Esse é um lead do incorporador', 'warning');
        }
      }
      this.buildForm();
      this.editFacService.setLoader(false);
    }, err => {
      this.editFacService.setLoader(false);
      this.snackbarService.show(err.error.messages ? err.error.messages[0].message
        : 'Não foi possível obter os dados desta fac.', 'error');
      this.closeModal();
    });
  }

  ngOnDestroy() {
    if (this.removeGlobalScroll) {
      this.windowService.enable();
    }
    this.loaderSubscription.unsubscribe();
  }

  checkOperationMarkets(): void {
    if (this.editFacService.featureOperationMarkets) {
      this.editFacService.checkOpMarkets().subscribe((resp: string[]) => {
        let opMkts = 0;
        if (resp.includes('PRIMARY')) {
          opMkts++;
        }
        if (resp.includes('SECONDARY')) {
          opMkts += 2;
        }
        this.operationMarkets = opMkts;
      });
    } else {
      this.operationMarkets = 3;
    }
  }

  buildForm() {
    this.geralForm = this.formBuilder.group({
      column_type: [this.columnType],
      contact_type: [''],
      return_date: [{}],
      visit_date: this.formBuilder.group({
        date: [null],
        hour: [null]
      }),
      description: [''],
      attachments: [[]],
      products: [[]]
    });

    this.moreInfoForm = this.formBuilder.group({
      person: this.formBuilder.group({
        rg: [this.facItem.person.rg],
        cpf: [this.facItem.person.cpf ? this.facItem.person.cpf : null, [validateCPF]],
        occupation: [this.facItem.person.occupation],
        spouse: [this.facItem.person.spouse],
        birth_date: [this.facItem.person.birth_date ? this.formatDate(this.facItem.person.birth_date) : null, [validateDateRange]]
      }),
      address: this.formBuilder.group({
        zip_code: [this.facItem.address.zip_code, [Validators.minLength(8)]],
        street: [this.facItem.address.street, [validateHaveCep]],
        number: [this.facItem.address.number],
        neighborhood: [this.facItem.address.neighborhood, [validateHaveCep]],
        complement: [this.facItem.address.complement],
        city: [this.facItem.address.city],
        state: [this.facItem.address.state],
      })
    });

    this.searchProfileForm = this.formBuilder.group({
      business_type: [''],
      bedrooms: [[]],
      suites: [[]],
      garage_spaces: [[]],
      max_cash_value: [0],
      min_cash_value: [0],
      max_area_value: [0],
      min_area_value: [0],
      property_type: [''],
      state: [''],
      city: [''],
      neighborhood_or_value_zone: [{ type: '', value: '' }],
      comments: [''],
    });
  }

  formatDate(date) { // Add UTC offset to date
    const currentOffSet = (new Date().getTimezoneOffset() / 60);
    return date.replace('T00:00:00.000Z', `T${('0' + currentOffSet).slice(-2)}:00:00.000Z`);
  }

  setFavorite(favorite: boolean) {
    this.facItem.is_favorite = favorite;
    this.favService.puthFavorite(
      {
        id: this.facdId,
        is_favorite: favorite
      }
    ).subscribe(() => { });
  }

  openSearchProfileEdit(isEdit: boolean, index: number) {
    this.searchProfileForm.reset();
    this.facItem.search_profiles.forEach(x => {
      x.max_cash_value = parseFloat(x.max_cash_value + '');
      x.min_cash_value = parseFloat(x.min_cash_value + '');
    });
    if (isEdit) {
      for (const key in this.facItem.search_profiles[index]) {
        if (this.searchProfileForm.get(key)) {
          const element = this.facItem.search_profiles[index][key];
          this.searchProfileForm.get(key).patchValue(element);
        }
      }
      this.searchProfileEditObj = {
        id: this.facItem.search_profiles[index].id,
        idx: index
      };
    } else {
      this.searchProfileEditObj = {
        id: null,
        idx: index
      };
    }
    this.openModal = true;
  }

  checkCloseModal() {
    if (this.facItem.funnel_stage.value.toLocaleLowerCase() !== this.geralForm.get('column_type').value.value.toLocaleLowerCase()
      || this.geralForm.get('attachments').value.length > 0
      || this.geralForm.get('products').value.length > 0) {
      this.popModal.description = this.modalDescriptions.changed;
      this.btnsService.show(this.popModal);
    } else if (this.geralForm.pristine) {
      this.closeModal();
    } else {
      this.popModal.description = this.modalDescriptions.same;
      this.btnsService.show(this.popModal);
    }
  }

  closeModal() {
    this.closeM.emit(false);
  }

  selectTab(tab: Tab) {
    this.tabs.forEach((item) => {
      if (item.id === tab.id) {
        item.active = true;
      } else {
        item.active = false;
      }
    });
  }

  toggleFilesUpload(event: any) {
    if (this.renderFilesUploadModal) {
      this.uploadModalHidden = event;
    } else {
      this.renderFilesUploadModal = true;
    }
  }

  toggleSearchProduct(event: boolean) {
    this.showSearchProductModal = event;
  }

  addAttachments(event: any) {
    this.geralForm.get('attachments').patchValue(event);
    this.geralForm.get('attachments').markAsDirty();
    this.uploadModalHidden = true;
  }

  addSearchProducts(event: any[]) {
    this.geralForm.get('products').patchValue(event);
    this.geralForm.get('products').markAsDirty();
  }

  closeSearchProfile() {
    this.searchProfileForm.reset();
    this.openModal = false;
  }

  openOffered() {
    this.showOfferedProduct = true;
  }

  openOriginLead() {
    this.showOriginLead = true;
  }

  private sendGATagOnOpenFAC() {
    this.googleTagService.pushTag({
      event: 'event',
      eventCategory: 'gestao_fac',
      eventAction: 'clique:abrir:fac',
      eventLabel: `status: ${this.facItem.funnel_stage.value}`,
      dimension8: this.facItem.fac_number
    });
  }
}
